module.exports = __webpack_public_path__ + "static/media/arrow-right.cc9f7da1.svg";